import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";

import { useSubscriptionsContext } from "@/contexts/subscriptions";
import SubsItem from "./SubsItem";

import styles from "./subscriptions.module.scss";

const SubsContent = () => {
  const { t } = useTranslation();
  const { fetchContent, date, content } = useSubscriptionsContext();
  const contentRef = useRef();
  const [width, setWidth] = useState(null);

  useEffect(() => {
    if (contentRef.current) {
      setWidth(contentRef.current.offsetWidth);
    }
  }, []);


  useEffect(() => {
    fetchContent();
  }, [fetchContent]);

  const renderItem = (contentItem, index) => {
    return <SubsItem key={contentItem.book_id} width={width} item={contentItem} index={index} />;
  };

  const dateContent = content[date] || [];

  if (!dateContent.length) {
    return (
      <div ref={contentRef} className={styles["subs-default-text"]}>
        {t("noSubs")}<br />{t("pleaseAddSub")}
      </div>
    );
  }

  return <div ref={contentRef}>{dateContent.map(renderItem)}</div>;
};

SubsContent.propTypes = {
  subsContent: PropTypes.object,
  setSubsContent: PropTypes.func
};

export default SubsContent;
